<template>
  <div class="examrusltDetail">
    <div class="mainLeft">
      <div class="quesTionTopItem">
        <div class="examName">{{ examPaper.paperTitle }}</div>
        <div class="examInfo">
          <div class="itemTxt">试题数量：{{ examPaper.questionTotal }}道</div>
          <div class="itemTxt">考试时间：{{ examPaper.examDurationTime }}分钟</div>
          <div class="itemTxt">满分：{{ examPaper.fullScore }}分</div>
        </div>
      </div>
      <div class="questionList">
        <div v-for="(item, index) in mapsQues" :id="index" :key="index" class="questionBox">
          <div class="nameType">
            <div class="type">【{{ typeMap[item.questionType - 1].name }}】</div>
            <div class="score">（本题{{ item.score }}分）</div>
            <div style="display:flex;margin-top:-5px;margin-left:auto;">
              <el-button
                v-if="
                  (item.questionType == 1 || item.questionType == 2 || item.questionType == 4) &&
                    isRootUser
                "
                :loading="hahaLoading"
                style="width:50px;height:30px;font-size:20px;border:0"
                @click="haha(item)"
              >
                😆
              </el-button>
              <el-button
                v-if="
                  (item.questionType == 1 || item.questionType == 2 || item.questionType == 4) &&
                    isRootUser
                "
                :loading="xixiLoading"
                style="margin-left:auto;width:50px;height:30px;font-size:20px;border:0"
                @click="xixi(item)"
              >
                👿
              </el-button>
            </div>
          </div>
          <div class="question">
            <div class="questionIndex">{{ index + 1 }}.</div>
            <div class="questionName">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div class="html" v-html="item.questionName"></div>
            </div>
            <div
              v-if="
                (item.questionType == 3 ||
                  item.questionType == 5 ||
                  item.questionType == 6 ||
                  item.questionType == 7 ||
                  item.questionType == 8 ||
                  item.questionType == 9) &&
                  isRootUser
              "
              class="questionBtn"
              @click="handleOpenDialog(1, item)"
            >
              {{ index + 1 }}
            </div>
          </div>
          <div class="optionList">
            <div v-if="item.questionType == 1 || item.questionType == 2" class="chooseQues">
              <div v-for="(v, key) in item.optionList" :key="key" class="optionBox">
                <div
                  class="optionsIteml"
                  :class="{
                    activeCls: v.checked == true,
                  }"
                >
                  {{ renderIndex(key) }}
                </div>
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div class="optionsItemr" v-html="v.optionName"></div>
              </div>
              <div class="itemUserBox">
                <div class="flexBox">
                  <div class="itemOne">
                    正确答案<span class="itemTwo">{{ item.rightAnswer }}</span>
                  </div>
                  <div class="itemOne">
                    考生答案<span class="itemThr">{{
                      item.userAnswer ? item.userAnswer : '未作答'
                    }}</span>
                  </div>
                  <div v-if="item.isRight == false && item.userAnswer" class="itemFou">
                    回答错误
                  </div>
                  <div v-if="item.isRight == true" class="itemFiv">回答正确</div>
                  <div v-else></div>
                </div>
              </div>
              <div class="itemRightBox">
                <div class="itemOne">
                  考生得分<span>{{ item.userScore }}</span>
                </div>
              </div>
            </div>
            <div v-if="item.questionType == 4" class="judgeCard">
              <div class="judgeQues">
                <div v-for="(v, key) in item.optionList" :key="key" class="judgeQuesbox">
                  <div
                    class="optionsIteml"
                    :class="{
                      activeCls: v.checked == true,
                    }"
                  >
                    {{ judgeQuesrenderIndex(key) }}
                  </div>
                </div>
              </div>
              <div class="itemUserBox">
                <div class="flexBox">
                  <div class="itemOne">
                    正确答案<span class="itemTwo">{{ item.rightAnswer }}</span>
                  </div>
                  <div class="itemOne">
                    考生答案<span class="itemThr">{{
                      item.userAnswer ? item.userAnswer : '未作答'
                    }}</span>
                  </div>
                  <div v-if="item.isRight == false && item.userAnswer" class="itemFou">
                    回答错误
                  </div>
                  <div v-if="item.isRight == true" class="itemFiv">回答正确</div>
                  <div v-else></div>
                </div>
              </div>
              <div class="itemRightBox">
                <div class="itemOne">
                  考生得分<span>{{ item.userScore }}</span>
                </div>
              </div>
            </div>
            <div
              v-if="
                item.questionType == 3 ||
                  item.questionType == 5 ||
                  item.questionType == 6 ||
                  item.questionType == 7 ||
                  item.questionType == 8 ||
                  item.questionType == 9
              "
              class="blanksQues"
            >
              <div class="UserAnwserBox">
                <div style="display:flex">
                  <div class="subtitle">【考生答案】</div>
                  <div v-if="isRootUser" class="questionBtn" @click="handleOpenDialog(2, item)">
                    {{ index + 1 }}
                  </div>
                </div>
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div class="text" v-html="item.userAnswer"></div>
              </div>
              <!-- <div class="SystemAnwserBox"> -->
              <!-- <div class="subtitle">【标准答案】</div> -->
              <!-- eslint-disable-next-line vue/no-v-html -->
              <!-- <div class="text" v-html="item.rightAnswer"></div> -->
              <!-- </div> -->
              <div class="UserScoreBox">
                <div class="itemOne">
                  考生得分
                  <span>{{ item.userScore }}</span>
                </div>
                <div v-if="isRootUser" class="questionBtn" @click="handleOpenDialog(3, item)">
                  {{ index + 1 }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 存在非选择题/判断题的题目且当前用户为 isRootUser 时才显示 -->
    <div v-if="isRootUser && answerItems.length > 0" class="rightQuestion">
      <div
        v-for="(v, index) in answerItems"
        :key="index"
        class="answerItem"
        :style="{ top: v.top + 'px', height: v.height + 'px' }"
      >
        <div class="answerTitle">【参考答案】</div>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div class="answerContent" v-html="v.item.rightAnswer"></div>
      </div>
    </div>
    <div class="mainRight">
      <div class="examresult">
        <div class="itemOne">考试结果</div>
        <div class="mainBox">
          <div class="itemTwo pt">考试结果</div>
          <div class="itemThr">{{ examPaper.finalScore }}分</div>
        </div>
        <div class="mainBox">
          <div class="itemTwo">交卷时间</div>
          <div class="itemfou">{{ examPaper.submitTime }}</div>
        </div>
        <div class="mainBox mt">
          <div class="itemTwo mt">考试姓名</div>
          <div class="itemfou mt">{{ examPaper.userName }}</div>
        </div>
        <div class="mainBox">
          <div class="itemTwo">准考证号</div>
          <div class="itemfou">{{ examPaper.admissionTicketId }}</div>
        </div>
        <div class="mainBox">
          <div class="itemTwo">身份证号</div>
          <div class="itemfou">{{ examPaper.idCard }}</div>
        </div>
      </div>
      <div class="examQuesBox">
        <div class="topItem">
          <div class="boxCard">
            <div class="boxFlex">
              <div class="itemOme"></div>
              <div class="txt">正确</div>
            </div>
            <div class="boxFlex">
              <div class="itemTwo"></div>
              <div class="txt">错误</div>
            </div>
            <div class="boxFlex">
              <div class="itemthr"></div>
              <div class="txt">未作答</div>
            </div>
            <div class="boxFlex">
              <div class="itemFou"></div>
              <div class="txt">主观题</div>
            </div>
          </div>
        </div>
        <div class="BotItem">
          <div v-if="mapsQues1.length > 0" class="boxFlex">
            <div class="subBox">
              <div class="line"></div>
              <div class="subQuesName">单选题</div>
            </div>
            <div class="boxQues">
              <div v-for="(v, key) in mapsQues1" :key="key" class="BotBox" @click="goItem(key)">
                <div v-if="v.isSubmit == true">
                  <div v-if="v.isRight == true" class="wrapBox1">{{ key + 1 }}</div>
                  <div v-if="v.isRight == false" class="wrapBox2">{{ key + 1 }}</div>
                </div>
                <div v-else class="wrapBox3">{{ key + 1 }}</div>
              </div>
            </div>
          </div>
          <div v-if="mapsQues2.length > 0" class="boxFlex">
            <div class="subBox">
              <div class="line"></div>
              <div class="subQuesName">多选题</div>
            </div>
            <div class="boxQues">
              <div
                v-for="(v, key) in mapsQues2"
                :key="key"
                class="BotBox"
                @click="goItem(mapsQues1.length + key)"
              >
                <div v-if="v.isSubmit == true">
                  <div v-if="v.isRight == true" class="wrapBox1">
                    {{ mapsQues1.length + key + 1 }}
                  </div>
                  <div v-if="v.isRight == false" class="wrapBox2">
                    {{ mapsQues1.length + key + 1 }}
                  </div>
                </div>
                <div v-else class="wrapBox3">{{ mapsQues1.length + key + 1 }}</div>
              </div>
            </div>
          </div>
          <div v-if="mapsQues3.length > 0" class="boxFlex">
            <div class="subBox">
              <div class="line"></div>
              <div class="subQuesName">计算题</div>
            </div>
            <div class="boxQues">
              <div
                v-for="(v, key) in mapsQues3"
                :key="key"
                class="BotBox"
                @click="goItem(mapsQues1.length + mapsQues2.length + key)"
              >
                <div v-if="v.isSubmit == true" class="wrapBox4">
                  {{ mapsQues1.length + mapsQues2.length + key + 1 }}
                </div>
                <div v-else class="wrapBox3">
                  {{ mapsQues1.length + mapsQues2.length + key + 1 }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="mapsQues4.length > 0" class="boxFlex">
            <div class="subBox">
              <div class="line"></div>
              <div class="subQuesName">判断题</div>
            </div>
            <div class="boxQues">
              <div
                v-for="(v, key) in mapsQues4"
                :key="key"
                class="BotBox"
                @click="goItem(mapsQues1.length + mapsQues2.length + mapsQues3.length + key)"
              >
                <div v-if="v.isSubmit == true">
                  <div v-if="v.isRight == true" class="wrapBox1">
                    {{ mapsQues1.length + mapsQues2.length + mapsQues3.length + key + 1 }}
                  </div>
                  <div v-if="v.isRight == false" class="wrapBox2">
                    {{ mapsQues1.length + mapsQues2.length + mapsQues3.length + key + 1 }}
                  </div>
                </div>
                <div v-else class="wrapBox3">
                  {{ mapsQues1.length + mapsQues2.length + mapsQues3.length + key + 1 }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="mapsQues5.length > 0" class="boxFlex">
            <div class="subBox">
              <div class="line"></div>
              <div class="subQuesName">填空题</div>
            </div>
            <div class="boxQues">
              <div
                v-for="(v, key) in mapsQues5"
                :key="key"
                class="BotBox"
                @click="
                  goItem(
                    mapsQues1.length + mapsQues2.length + mapsQues3.length + mapsQues4.length + key,
                  )
                "
              >
                <div v-if="v.isSubmit == true" class="wrapBox4">
                  {{
                    mapsQues1.length +
                      mapsQues2.length +
                      mapsQues3.length +
                      mapsQues4.length +
                      key +
                      1
                  }}
                </div>
                <div v-else class="wrapBox3">
                  {{
                    mapsQues1.length +
                      mapsQues2.length +
                      mapsQues3.length +
                      mapsQues4.length +
                      key +
                      1
                  }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="mapsQues6.length > 0" class="boxFlex">
            <div class="subBox">
              <div class="line"></div>
              <div class="subQuesName">简答题</div>
            </div>
            <div class="boxQues">
              <div
                v-for="(v, key) in mapsQues6"
                :key="key"
                class="BotBox"
                @click="
                  goItem(
                    mapsQues1.length +
                      mapsQues2.length +
                      mapsQues3.length +
                      mapsQues4.length +
                      mapsQues5.length +
                      key,
                  )
                "
              >
                <div v-if="v.isSubmit == true" class="wrapBox4">
                  {{
                    mapsQues1.length +
                      mapsQues2.length +
                      mapsQues3.length +
                      mapsQues4.length +
                      mapsQues5.length +
                      key +
                      1
                  }}
                </div>
                <div v-else class="wrapBox3">
                  {{
                    mapsQues1.length +
                      mapsQues2.length +
                      mapsQues3.length +
                      mapsQues4.length +
                      mapsQues5.length +
                      key +
                      1
                  }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="mapsQues7.length > 0" class="boxFlex">
            <div class="subBox">
              <div class="line"></div>
              <div class="subQuesName">论述题</div>
            </div>
            <div class="boxQues">
              <div
                v-for="(v, key) in mapsQues7"
                :key="key"
                class="BotBox"
                @click="
                  goItem(
                    mapsQues1.length +
                      mapsQues2.length +
                      mapsQues3.length +
                      mapsQues4.length +
                      mapsQues5.length +
                      mapsQues6.length +
                      key,
                  )
                "
              >
                <div v-if="v.isSubmit == true" class="wrapBox4">
                  {{
                    mapsQues1.length +
                      mapsQues2.length +
                      mapsQues3.length +
                      mapsQues4.length +
                      mapsQues5.length +
                      mapsQues6.length +
                      key +
                      1
                  }}
                </div>
                <div v-else class="wrapBox3">
                  {{
                    mapsQues1.length +
                      mapsQues2.length +
                      mapsQues3.length +
                      mapsQues4.length +
                      mapsQues5.length +
                      mapsQues6.length +
                      key +
                      1
                  }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="mapsQues8.length > 0" class="boxFlex">
            <div class="subBox">
              <div class="line"></div>
              <div class="subQuesName">案例分析题</div>
            </div>
            <div class="boxQues">
              <div
                v-for="(v, key) in mapsQues8"
                :key="key"
                class="BotBox"
                @click="
                  goItem(
                    mapsQues1.length +
                      mapsQues2.length +
                      mapsQues3.length +
                      mapsQues4.length +
                      mapsQues5.length +
                      mapsQues6.length +
                      mapsQues7.length +
                      key,
                  )
                "
              >
                <div v-if="v.isSubmit == true" class="wrapBox4">
                  {{
                    mapsQues1.length +
                      mapsQues2.length +
                      mapsQues3.length +
                      mapsQues4.length +
                      mapsQues5.length +
                      mapsQues6.length +
                      mapsQues7.length +
                      key +
                      1
                  }}
                </div>
                <div v-else class="wrapBox3">
                  {{
                    mapsQues1.length +
                      mapsQues2.length +
                      mapsQues3.length +
                      mapsQues4.length +
                      mapsQues5.length +
                      mapsQues6.length +
                      mapsQues7.length +
                      key +
                      1
                  }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="mapsQues9.length > 0" class="boxFlex">
            <div class="subBox">
              <div class="line"></div>
              <div class="subQuesName">综合题</div>
            </div>
            <div class="boxQues">
              <div
                v-for="(v, key) in mapsQues9"
                :key="key"
                class="BotBox"
                @click="
                  goItem(
                    mapsQues1.length +
                      mapsQues2.length +
                      mapsQues3.length +
                      mapsQues4.length +
                      mapsQues5.length +
                      mapsQues6.length +
                      mapsQues7.length +
                      mapsQues8.length +
                      key,
                  )
                "
              >
                <div v-if="v.isSubmit == true" class="wrapBox4">
                  {{
                    mapsQues1.length +
                      mapsQues2.length +
                      mapsQues3.length +
                      mapsQues4.length +
                      mapsQues5.length +
                      mapsQues6.length +
                      mapsQues7.length +
                      mapsQues8.length +
                      key +
                      1
                  }}
                </div>
                <div v-else class="wrapBox3">
                  {{
                    mapsQues1.length +
                      mapsQues2.length +
                      mapsQues3.length +
                      mapsQues4.length +
                      mapsQues5.length +
                      mapsQues6.length +
                      mapsQues7.length +
                      mapsQues8.length +
                      key +
                      1
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="photo-list">
        <div class="title">人脸照片</div>
        <el-image
          v-for="item in userPhotoUrlMap"
          :key="item.id"
          style="width: 240px; height: 136px"
          :src="item.url"
          :preview-src-list="userPhotoUrlMap.map(item => item.url)"
        >
        </el-image>
        <el-upload
          ref="upload"
          action="/api/third/api/tencentUpload/upload/file/local"
          accept=".png,.jpg,.jpge"
          :limit="100"
          :multiple="true"
          :show-file-list="false"
          :on-success="handleUploadSuccess"
        >
          <el-button type="primary">上传照片</el-button>
        </el-upload>
      </div>
    </div>
    <DialogResult ref="DialogResult" @success="handleGetExamList"></DialogResult>
  </div>
</template>
<script>
import to from 'await-to'
import { examRecordInfo, examPhotoAddRecord } from '@/api/exam'
import { mapGetters } from 'vuex'
import { haha, xixi } from '@/api/system'
import DialogResult from './component/dialog.vue'
export default {
  name: 'ExamrusltDetail',
  components: {
    DialogResult,
  },
  data() {
    return {
      rootID: process.env.VUE_APP_ROOT_USERID,
      examPaper: {},
      examRecordId: this.$route.query.id || '',
      typeMap: [
        { name: '单选题' },
        { name: '多选题' },
        { name: '计算题' },
        { name: '判断题' },
        { name: '填空题' },
        { name: '简答题' },
        { name: '论述题' },
        { name: '案例分析题' },
        { name: '综合题' },
      ],
      mapsQues1: [], //单选题
      mapsQues2: [], //多选题
      mapsQues3: [], //计算题
      mapsQues4: [], //判断题
      mapsQues5: [], //填空题
      mapsQues6: [], //简答题
      mapsQues7: [], //论述题
      mapsQues8: [], //案列分析题
      mapsQues9: [], //综合题
      mapsQues: [],
      answerItems: [],
      hahaLoading: false,
      userPhotoUrlMap: [],
      xixiLoading: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isRootUser() {
      return (
        JSON.parse(this.rootID).includes(this.userInfo.id) &&
        sessionStorage.getItem('rootUserSwitch') === '1'
      )
    },
  },
  mounted() {
    this.handleGetExamList()
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  },
  methods: {
    handleOpenDialog(type, v) {
      this.$refs.DialogResult.show(type, v)
    },
    canShowAnswer(questionType) {
      // 非选择题（单选、多选）和判断题才显示参考答案
      return questionType != 1 && questionType != 2 && questionType != 4
    },
    handleTrackAnswerHeights() {
      const left = document.querySelector('.mainLeft')
      const boxes = left ? left.querySelectorAll('.questionBox') : []
      if (!boxes.length) {
        this.answerItems = []
        return
      }
      const leftTop = left.getBoundingClientRect().top
      const items = []
      this.mapsQues.forEach((item, index) => {
        const box = boxes[index]
        if (!box || !this.canShowAnswer(item.questionType)) return
        const rect = box.getBoundingClientRect()
        // 仅第一题为主观题时，答案块从页面顶部开始（补上试卷标题高度）；否则从对应题目顶部开始
        const top = index === 0 ? leftTop : rect.top
        items.push({
          top: top - leftTop,
          height: rect.bottom - top,
          item,
        })
      })
      this.answerItems = items
    },
    initResizeObserver() {
      if (typeof ResizeObserver === 'undefined') return
      const list = document.querySelector('.mainLeft .questionList')
      if (!list) return
      if (!this.resizeObserver) {
        this.resizeObserver = new ResizeObserver(() => {
          this.handleTrackAnswerHeights()
        })
      }
      this.resizeObserver.observe(list)
    },
    async handleGetExamList() {
      const [res, err] = await to(examRecordInfo({ examRecordId: this.examRecordId }))
      if (err) return this.$message.warning(err.msg)
      if (res.data.questionList) {
        res.data.questionList.forEach(element => {
          if (element.questionName) {
            element.questionName = element.questionName.replace(
              /<img/g,
              "<img style='max-width: 100% !important;'",
            )
          }
        })
      }
      this.examPaper = res.data

      this.userPhotoUrlMap = Object.keys(this.examPaper.userPhotoUrlMap).map(key => {
        return {
          id: key,
          url: this.examPaper.userPhotoUrlMap[key],
        }
      })
      this.mapsQues1 = this.examPaper.questionList.filter(item => {
        return item.questionType == 1
      })
      this.mapsQues2 = this.examPaper.questionList.filter(item => {
        return item.questionType == 2
      })
      this.mapsQues3 = this.examPaper.questionList.filter(item => {
        return item.questionType == 3
      })
      this.mapsQues4 = this.examPaper.questionList.filter(item => {
        return item.questionType == 4
      })
      this.mapsQues5 = this.examPaper.questionList.filter(item => {
        return item.questionType == 5
      })
      this.mapsQues6 = this.examPaper.questionList.filter(item => {
        return item.questionType == 6
      })
      this.mapsQues7 = this.examPaper.questionList.filter(item => {
        return item.questionType == 7
      })
      this.mapsQues8 = this.examPaper.questionList.filter(item => {
        return item.questionType == 8
      })
      this.mapsQues9 = this.examPaper.questionList.filter(item => {
        return item.questionType == 9
      })
      this.mapsQues = [
        ...this.mapsQues1,
        ...this.mapsQues2,
        ...this.mapsQues3,
        ...this.mapsQues4,
        ...this.mapsQues5,
        ...this.mapsQues6,
        ...this.mapsQues7,
        ...this.mapsQues8,
        ...this.mapsQues9,
      ]
      this.$nextTick(() => {
        this.handleTrackAnswerHeights()
        this.initResizeObserver()
      })
    },
    goItem(key) {
      this.$nextTick(() => {
        document
          .getElementById(key)
          .scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' })
      })
    },
    renderIndex(index) {
      let transArr = ['A', 'B', 'C', 'D', 'E', 'F']
      return transArr[index]
    },
    judgeQuesrenderIndex(index) {
      let transArr = ['对', '错']
      return transArr[index]
    },
    async haha(item) {
      this.hahaLoading = true
      const [, err] = await to(
        haha({ examRecordId: this.examRecordId, questionId: item.questionId }),
      )
      this.hahaLoading = false
      if (err) return this.$message.warning(err.msg)
      this.$message.success('操作成功')
    },
    async xixi(item) {
      this.xixiLoading = true
      const [, err] = await to(
        xixi({ examRecordId: this.examRecordId, questionId: item.questionId }),
      )
      this.xixiLoading = false
      if (err) return this.$message.warning(err.msg)
      this.$message.success('操作成功')
    },
    async handleUploadSuccess(response) {
      console.log(`output->response`, response)
      const [res, err] = await to(
        examPhotoAddRecord({
          recordId: this.examRecordId,
          url: response.data,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      this.userPhotoUrlMap.push({
        id: res.data,
        url: response.data,
      })
    },
  },
}
</script>
<style scoped lang="scss">
.examrusltDetail {
  display: flex;
  .mainLeft {
    // margin-left: 250px;
    width: 880px;
    height: auto;
    .quesTionTopItem {
      width: 100%;
      height: 110px;
      background: #ffffff;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      .examName {
        padding-top: 30px;
        font-size: 30px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #333333;
        line-height: 30px;
        text-align: center;
      }
      .examInfo {
        width: 440px;
        margin: 16px auto 0 auto;
        display: flex;
        justify-content: space-between;
        .itemTxt {
          font-size: 14px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #909399;
        }
      }
    }
    .questionList {
      margin-top: 1px;
      // 底部留出间距，避免最后一题被页面底部遮住
      padding-bottom: 20px;
      .questionBox {
        // width: 100%;
        background: #ffffff;
        margin-bottom: 10px;
        padding: 20px 30px;
        .nameType {
          display: flex;
          .type {
            font-size: 16px;
            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
            font-weight: bold;
            color: #3671bf;
            line-height: 16px;
          }
          .score {
            margin-left: 20px;
            font-size: 16px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #909399;
            line-height: 16px;
          }
        }
        .question {
          display: flex;
          margin-left: 5px;
          margin-top: 15px;
          .questionIndex {
            font-size: 18px;
            font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
            font-weight: normal;
            color: #333333;
            line-height: 28px;
          }
          .questionName {
            flex-wrap: wrap;
            font-size: 18px;
            font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
            font-weight: normal;
            color: #333333;
            line-height: 28px;
            margin-left: 10px;
            white-space: normal;
            word-break: break-all;
            overflow: hidden;
            text-align: left;
          }
          .questionBtn {
            // height: 28px;
            padding: 0px 10px;
            border: 1px solid #333333;
            line-height: 28px;
            border-radius: 4px;
            cursor: pointer;
            margin-left: 5px;
          }
        }
        .optionList {
          .chooseQues {
            // display: flex;
            margin-top: 20px;
            .optionBox {
              display: flex;
              margin-left: 25px;
              .optionsIteml {
                width: 28px;
                height: 28px;
                border-radius: 50%;
                border: 1px solid #d8dee6;
                color: #4d4d4d;
                font-size: 16px;
                flex-shrink: 0;
                font-weight: normal;
                text-align: center;
                margin-bottom: 16px;
                margin-right: 10px;
              }
              .activeCls {
                background: #3671bf;
                color: #ffffff;
              }
              .optionsItemr {
                font-size: 14px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #444444;
                line-height: 28px;
                flex-wrap: wrap;
              }
            }
            .itemUserBox {
              margin-top: 4px;
              height: 50px;
              background: #f5f8fc;
              border-radius: 0px 0px 0px 0px;
              opacity: 1;
              .flexBox {
                width: 340px;
                display: flex;
                justify-content: space-between;
                padding-left: 20px;
                font-size: 14px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                line-height: 50px;
                .itemOne {
                  color: #808080;
                }
                .itemTwo {
                  margin-left: 14px;
                  color: #45bb6d;
                }
                .itemThr {
                  margin-left: 14px;
                  color: #3671bf;
                }
                .itemFou {
                  color: #ff3b3a;
                }
                .itemFiv {
                  color: #45bb6d;
                }
              }
            }
            .itemRightBox {
              margin-top: 10px;
              height: 50px;
              background: #f5f8fc;
              border-radius: 0px 0px 0px 0px;
              opacity: 1;
              .itemOne {
                padding-left: 20px;
                font-size: 14px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #808080;
                line-height: 50px;
                span {
                  margin-left: 14px;
                  color: #ff3b3a;
                }
              }
            }
          }
          .judgeCard {
            .judgeQues {
              display: flex;
              margin-top: 24px;
              .judgeQuesbox {
                margin-left: 25px;
                .optionsIteml {
                  width: 100px;
                  height: 30px;
                  background: #ffffff;
                  border-radius: 4px 4px 4px 4px;
                  opacity: 1;
                  border: 1px solid #d8dee6;
                  text-align: center;
                  font-size: 14px;
                  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                  font-weight: 400;
                  color: #4d4d4d;
                  line-height: 30px;
                }
                .activeCls {
                  background: #3671bf;
                  color: #ffffff;
                }
              }
            }
            .itemUserBox {
              margin-top: 20px;
              height: 50px;
              background: #f5f8fc;
              border-radius: 0px 0px 0px 0px;
              opacity: 1;
              .flexBox {
                width: 340px;
                display: flex;
                justify-content: space-between;
                padding-left: 20px;
                font-size: 14px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                line-height: 50px;
                .itemOne {
                  color: #808080;
                }
                .itemTwo {
                  margin-left: 14px;
                  color: #45bb6d;
                }
                .itemThr {
                  margin-left: 14px;
                  color: #3671bf;
                }
                .itemFou {
                  color: #ff3b3a;
                }
                .itemFiv {
                  color: #45bb6d;
                }
              }
            }
            .itemRightBox {
              margin-top: 10px;
              height: 50px;
              background: #f5f8fc;
              border-radius: 0px 0px 0px 0px;
              opacity: 1;
              .itemOne {
                padding-left: 20px;
                font-size: 14px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #808080;
                line-height: 50px;
                span {
                  margin-left: 14px;
                  color: #ff3b3a;
                }
              }
            }
          }
          .blanksQues {
            margin-top: 20px;
            .UserAnwserBox {
              // max-height: 360px;
              background: #f5f8fc;
              border-radius: 0px 0px 0px 0px;
              opacity: 1;
              border: 1px solid #e4eaf2;
              padding: 20px 30px;
              overflow-x: hidden;
              overflow-y: scroll;
              .subtitle {
                font-size: 16px;
                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                font-weight: 500;
                color: #3671bf;
                line-height: 30px;
              }
              .text {
                margin-top: 21px;
                font-size: 16px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #666666;
              }
              .questionBtn {
                padding: 0px 10px;
                border: 1px solid #333333;
                line-height: 28px;
                border-radius: 4px;
                cursor: pointer;
                margin-left: 5px;
              }
            }
            .UserAnwserBox::-webkit-scrollbar {
              display: none;
            }
            .SystemAnwserBox {
              max-height: 360px;
              margin-top: 16px;
              background: #f7fcf9;
              border-radius: 0px 0px 0px 0px;
              opacity: 1;
              border: 1px solid #e4eaec;
              padding: 20px 30px;
              overflow-x: hidden;
              overflow-y: scroll;
              .subtitle {
                font-size: 16px;
                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                font-weight: 500;
                color: #45bb6d;
                line-height: 16px;
              }
              .text {
                margin-top: 21px;
                font-size: 16px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #666666;
              }
            }
            .SystemAnwserBox::-webkit-scrollbar {
              display: none;
            }
            .UserScoreBox {
              margin-top: 21px;
              height: 50px;
              background: #f5f8fc;
              border-radius: 0px 0px 0px 0px;
              opacity: 1;
              display: flex;
              .itemOne {
                padding-left: 20px;
                font-size: 14px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #808080;
                line-height: 50px;
                span {
                  margin-left: 14px;
                  color: #ff3b3a;
                }
              }
              .questionBtn {
                margin-top: 10px;
                height: 30px;
                padding: 0px 10px;
                border: 1px solid #333333;
                line-height: 30px;
                border-radius: 4px;
                cursor: pointer;
                margin-left: 20px;
              }
            }
          }
        }
      }
    }
  }
  .rightQuestion {
    position: relative;
    flex: 1;
    min-width: 300px;
    margin-left: 30px;
    box-sizing: border-box;
    .answerItem {
      position: absolute;
      left: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      background: #ffffff;
      border: 1px solid #e4eaf2;
      border-radius: 4px;
      padding: 20px;
      box-sizing: border-box;
      overflow: hidden;
      .answerTitle {
        flex-shrink: 0;
        font-size: 16px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #3671bf;
        line-height: 30px;
      }
      .answerContent {
        flex: 1;
        margin-top: 10px;
        overflow-y: auto;
        font-size: 16px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        line-height: 28px;
        word-break: break-all;
        img {
          max-width: 100% !important;
        }
      }
    }
  }
  .mainRight {
    margin-left: 30px;
    width: 290px;
    .examresult {
      padding: 20px;
      background: #ffffff;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      .itemOne {
        font-size: 20px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        text-align: center;
        margin-bottom: 12px;
      }
      .mainBox {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        .pt {
          padding-top: 10px;
        }
        .itemTwo {
          font-size: 14px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          line-height: 14px;
        }
        .itemThr {
          font-size: 24px;
          font-family: Source Han Sans CN-Bold, Source Han Sans CN;
          font-weight: bold;
          color: #ff5554;
          line-height: 24px;
        }
        .mt {
          padding-top: 12px;
        }
        .itemfou {
          font-size: 14px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 14px;
        }
      }
    }
    .examQuesBox {
      margin-top: 20px;
      background: #ffffff;
      .topItem {
        height: 54px;
        border-bottom: 1px solid #ebeef5;
        .boxCard {
          padding: 20px 16px;
          display: flex;
          justify-content: space-between;
          .boxFlex {
            display: flex;
            .itemOme {
              width: 16px;
              height: 14px;
              background: #45bb6d;
              border-radius: 2px 2px 2px 2px;
              margin-right: 4px;
            }
            .itemTwo {
              width: 16px;
              height: 14px;
              background: #ff5554;
              border-radius: 2px 2px 2px 2px;
              margin-right: 4px;
            }
            .itemthr {
              width: 16px;
              height: 14px;
              background: #d7dae0;
              border-radius: 2px 2px 2px 2px;
              margin-right: 4px;
            }
            .itemFou {
              width: 16px;
              height: 14px;
              background: #ffaf37;
              border-radius: 2px 2px 2px 2px;
              margin-right: 4px;
            }
            .txt {
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #333333;
              line-height: 14px;
            }
          }
        }
      }
      .BotItem {
        padding: 4px 26px 20px 20px;
        // display: flex;
        // // justify-content: space-between;
        // flex-wrap: wrap;
        // display: grid;
        // grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        .boxFlex {
          margin-top: 20px;
          .subBox {
            display: flex;
            .line {
              width: 3px;
              height: 16px;
              background: #3179e4;
              border-radius: 2px 2px 2px 2px;
              margin-right: 4px;
            }
            .subQuesName {
              font-size: 16px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #666666;
              line-height: 16px;
            }
          }
          .boxQues {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
            .BotBox {
              width: 36px;
              height: 28px;
              border-radius: 2px 2px 2px 2px;
              opacity: 1;
              font-size: 16px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              line-height: 28px;
              text-align: center;
              margin-top: 16px;
              margin-right: 16px;
              cursor: pointer;
              // &:nth-child(5n) {
              //   margin-right: 0px;
              // }
              .wrapBox1 {
                background: #45bb6d;
              }
              .wrapBox2 {
                background: #ff5554;
              }
              .wrapBox3 {
                background: #d7dae0;
              }
              .wrapBox4 {
                background: #ffaf37;
              }
            }
          }
        }
      }
    }
    .photo-list {
      margin-top: 20px;
      background: #ffffff;
      padding: 20px;
      .title {
        font-size: 20px;
        font-weight: 400;
        color: #333333;
        text-align: center;
        margin-bottom: 12px;
      }
      .el-image {
        margin-bottom: 10px;
      }
      /deep/.el-upload {
        display: block;
        margin: 10px auto;
      }
    }
  }
}
</style>
